const Logout = () => {
    let token = localStorage.getItem("token");
    let user = localStorage.getItem("user");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    fetch(process.env.REACT_APP_BACKEND_URL + 'logout', {
        method: "POST",
        headers: {
            "Content-Type": "text/plain",
        },
        body: JSON.stringify({ token: token, username: user }),
    }).then(response => {
        if (response.ok) {
            window.location.href = "/";
        }
    });
    return null;
};

export default Logout;